import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import App from './app/App';
import store from './app/configureStore'


window.localStorage.setItem('debug', '*');
const container = document.getElementById('job-openings');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);
